import React from 'react'
import {Card, Row, Col} from 'react-bootstrap';
import {useState} from "react"
import "./contactus.scss";
import StatusContext from '../../../contexts/StatusContext'
import ContactusContext from "../../../contexts/ContactusContext";
import {ViewContacts} from './ViewContacts'
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack'
import { PushButton } from '../pushbutton/PushButton';


export const ContactUs = () => {

  const[inputs, setInputs] = useState({
    name:"",
    companyname:"",
    email:"",
    subject:"",
    text:""
  })

  let {
    changeLanguage,
    isMe,
} = React.useContext(StatusContext);

  let {
   status,
   setStatus,
   getData,
   saveData,
   contacts,
   sendEmail,
     } = React.useContext(ContactusContext);

  

  
  const handleChange = (e) => {
    setInputs((prev)=>({...prev,[e.target.name]: e.target.value }))
  }

  
  // eslint-disable-next-line
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const isValidEmail = (email) => {
    return emailRegex.test(String(email).toLowerCase());
  }
  

  const handleSend = async (e)=> {
   
    e.preventDefault()
    setStatus("")
   
    if (inputs.name.length === 0)
    {
      setStatus("Please enter a name.")
      return;
    }
  
    if (!isValidEmail(inputs.email))
    {
      setStatus("Invalid email...")
      return;
    }

    if (inputs.text.length === 0)
    {
      setStatus("Please enter a text...")
      return;
    }

    //addContact(inputs)className='payasyougoTitle'
    sendEmail(inputs)
      }

  return (
    <div className="homeContainer">
    
   
     
    <div className="contactus">
      <Card>
        <div className="right">
          <h2 className='payasyougoTitle'>{changeLanguage('contactus', 'title')}</h2>
          <h6 className='payasyougoTitle'>{changeLanguage('contactus', 'subtitle2')}</h6>
          <h6 className='payasyougoTitle'>{changeLanguage('contactus', 'subtitle1')}</h6>
      
          <br></br>
          <form>
            {/*
            <input type="text" placeholder={changeLanguage('contactus', 'placeholdername')} name="name" onChange={handleChange}/>
            <input type="text" placeholder={changeLanguage('contactus', 'placeholdercompanyname')} name="companyname" onChange={handleChange}/>
            <input type="email" placeholder={changeLanguage('contactus', 'placeholderemail')} name="email" onChange={handleChange}/>
            <input type="text" placeholder={changeLanguage('contactus', 'placeholdersubject')} name="subject" onChange={handleChange}/>
  */}
           

            <TextField style={{marginTop:'-15px'}}
                autoFocus
                required
                margin="dense"
              
                name="name"
                label={changeLanguage('contactus', 'placeholdername')}
                type="text"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {inputs.name}
              />
            
              <TextField style={{marginTop:'-15px'}}
                
                required
                margin="dense"
              
                name="companyname"
                label={changeLanguage('contactus', 'placeholdercompanyname')}
                type="text"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {inputs.companyname}
              />
       

              <TextField style={{marginTop:'-15px'}}
                
                required
                margin="dense"
              
                name="email"
                label={changeLanguage('contactus', 'placeholderemail')}
                type="email"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {inputs.email}
              />
              <TextField style={{marginTop:'-15px'}}
                
                required
                margin="dense"
              
                name="subject"
                label={changeLanguage('contactus', 'placeholdersubject')}
                type="text"
                fullWidth
                variant="standard"
                onChange = {handleChange}
                value = {inputs.subject}
              />

                <textarea className="form-control" style={{marginTop:'-15px'}} rows="5" placeholder="Text"
                     id="text" value = {inputs.text} name="text"
                     onChange={handleChange}>
                </textarea>
              
            {
            (status) &&
            <label style={{color:"red"}}>{status}</label>
            }
            
           
            <PushButton label={changeLanguage('contactus', 'buttonsend')} onClick={handleSend}/>
          
          </form>
        </div>
        </Card>
    </div>

 

    <div>
      {
             isMe() &&
             <>
                <div>
                    <Stack direction="row" spacing={2}>
                    <PushButton label='Get data' onClick={getData}/>
                    <PushButton label= 'Save data' onClick={saveData}/>
                    </Stack>
                    <br></br>
              </div>
              <Row >
                <Col>
                 <div className="templatesPromptArea" >
                  {
                    (contacts !== null) &&
                        <ViewContacts />
                  }
                 </div>
                </Col>
              </Row>
               </>
              
      }

    </div>
   
   
    </div>
    
  );
};


